// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3fdJy","tab":"ProcedureTabs_tab__3UeIV"};